import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuthStore } from '@stores/authStore'
import { useThemeStore } from '@stores/themeStore'
import { Layout } from '@components/layout/Layout'
import { LoginPage } from '@pages/auth/LoginPage'
import { ForgotPasswordPage } from '@pages/auth/ForgotPasswordPage'
import { DefinePasswordPage } from '@pages/auth/DefinePasswordPage'
import { HomePage } from '@pages/home/HomePage'
import { ProductsPage } from '@pages/products/ProductsPage'
import { ProductDetailsPage } from '@pages/products/ProductDetailsPage'
import { IngredientsPage } from '@pages/ingredients/IngredientsPage'
import { IngredientDetailsPage } from '@pages/ingredients/IngredientDetailsPage'
import { BrandsPage } from '@pages/brands/BrandsPage'
import { CategoriesPage } from '@pages/categories/CategoriesPage'
import { CertificationsPage } from '@pages/certifications/CertificationsPage'
import { ContinentsPage } from '@pages/continents/ContinentsPage'
import { LoginMessagePage } from '@pages/login-message/LoginMessagePage'
import { AdminsPage } from '@pages/admins/AdminsPage'
import { SettingsPage } from '@pages/settings/SettingsPage'
import ErrorBoundary from '@components/error/ErrorBoundary'
import { useEffect } from 'react'

function App() {
  const { user, initialize } = useAuthStore()
  const { theme } = useThemeStore()

  // Initialize theme and auth on app load
  useEffect(() => {
    if (theme === 'dark') {
      document.documentElement.classList.add('dark')
    } else {
      document.documentElement.classList.remove('dark')
    }
  }, [theme])

  // Initialize authentication
  useEffect(() => {
    initialize()
  }, [initialize])

  // If not authenticated, show auth routes
  if (!user) {
    return (
      <ErrorBoundary>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/auth/login" element={<LoginPage />} />
          <Route path="/auth/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/auth/define-password" element={<DefinePasswordPage />} />
          {/* Redirect any other route to login */}
          <Route path="*" element={<LoginPage />} />
        </Routes>
      </ErrorBoundary>
    )
  }

  return (
    <ErrorBoundary>
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/products/new" element={<ProductDetailsPage />} />
          <Route path="/products/:id" element={<ProductDetailsPage />} />
          <Route path="/ingredients" element={<IngredientsPage />} />
          <Route path="/ingredients/new" element={<IngredientDetailsPage />} />
          <Route path="/ingredients/:id" element={<IngredientDetailsPage />} />
          <Route path="/brands" element={<BrandsPage />} />
          <Route path="/categories" element={<CategoriesPage />} />
          <Route path="/certifications" element={<CertificationsPage />} />
          <Route path="/continents" element={<ContinentsPage />} />
          <Route path="/login-message" element={<LoginMessagePage />} />
          <Route path="/admins" element={<AdminsPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          {/* Redirect any auth routes or unknown routes to home */}
          <Route path="/auth/*" element={<Navigate to="/" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Layout>
    </ErrorBoundary>
  )
}

export default App